const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  userInfo: state => state.user.info,
  menus: state => state.permission.menus,
  routers: state => state.permission.routers,
  multiTab: state => state.app.multiTab,
  cachedViews: state => state.tagsView.cachedViews,
  dict: state => state.dict.dict,
  acityList: state => state.user.cityList,
  cityTotalNum: state => state.user.cityTotalNum,
  auditRedeemPending: state => state.auditReminder.redeemPending,
  auditWithdrawPending: state => state.auditReminder.withdrawPending,
  auditPendingTotal: state => Number(state.auditReminder.redeemPending) + Number(state.auditReminder.withdrawPending),
  csUnreadTotal: state => state.csMessageReminder.unreadTotal,
  pendingNoticeTotal: (state, getters) => {
    const perms = getters.permissions || []
    const all = perms.includes('*:*:*')
    let total = 0
    if (all || perms.includes('giftcard:redeem:list')) {
      total += Number(state.auditReminder.redeemPending) || 0
    }
    if (all || perms.includes('giftcard:withdraw:list')) {
      total += Number(state.auditReminder.withdrawPending) || 0
    }
    if (all || perms.includes('customer:workbench:view')) {
      total += Number(state.csMessageReminder.unreadTotal) || 0
    }
    return total
  }
}

export default getters
